




















































































import Vue from 'vue'
const sandboxTemplateHTML =
`<v-date-time-select
            :chips="chips"
            :dense="dense"
            :clearable="clearable"
            :dark="dark"
            :locale="currentLocale"
            :selectionType="selectionType"
          >
</v-date-time-select>`

const sandboxCode =
`export default ({
  data: () => ({
    chips: false,
    dense: false,
    clearable: false,
    dark: false,
    autocomplete: false,
    locale: 'en'
    selectionType: 'datetime',
  })
})`

export default Vue.extend({
  data: () => ({
    items: [],
    chips: false,
    multiple: false,
    dense: false,
    clearable: false,
    dark: false,
    autocomplete: false,
    customSlots: false,
    currentLocale: 'en',
    selectionType: 'datetime',
    textAlign: 'left',
    locales: ['en', 'ru', 'it', 'pt', 'pl', 'zh'],
    selectionTypes: ['date', 'time', 'datetime'],
    textAlignVarians: ['left', 'right', 'center'],
    codeSandbox: false,
    sandboxTemplate: sandboxTemplateHTML,
    sandboxCode: sandboxCode
  })
})
